import React from "react";
import fieldImage from "../assets/football_field.jpg";
import "./style.css";

const MatchLineup = ({ match, playerStats, cityName, leagueName }) => {
  const formatURL = (str) =>
    str
      .toLowerCase()
      .replace(/ç/g, "c")
      .replace(/ğ/g, "g")
      .replace(/ı/g, "i")
      .replace(/ö/g, "o")
      .replace(/ş/g, "s")
      .replace(/ü/g, "u")
      .replace(/[^a-z0-9 ]/g, "")
      .trim()
      .replace(/\s+/g, "-");

  const renderPlayers = (teamName, position) => {
    return playerStats
      .filter(
        (p) =>
          p.team?.team_name === teamName &&
          (position ? p.player_position === position : true)
      )
      .map((player, index) => (
        <div
          key={index}
          className="player-lineup"
          onClick={() =>
            (window.location.href = `/${formatURL(cityName)}/${formatURL(
              leagueName
            )}/oyuncular/${player.player.id}`)
          }
        >
          <img
            src={player.player.player_img}
            alt={player.player.player_name}
            className="player-img-mini"
          />
          <span>{player.player.player_name}</span>
        </div>
      ));
  };

  return (
    <div className="lineup-wrapper">
      <div className="team-lineup">
        <h3>{match.first_team_name}</h3>
        <div className="lineup-section">
          <h4>Kaleci</h4>
          {renderPlayers(match.first_team_name, "kaleci")}
          <h4>Defans</h4>
          {renderPlayers(match.first_team_name, "defans")}
          <h4>Orta Saha</h4>
          {renderPlayers(match.first_team_name, "orta saha")}
          <h4>Forvet</h4>
          {renderPlayers(match.first_team_name, "forvet")}
        </div>
      </div>

      <div className="lineup-field">
        <img src={fieldImage} alt="Saha" className="field-img" />
        <div className="field-labels">
          <span>{match.first_team_name}</span>
          <span>{match.second_team_name}</span>
        </div>
      </div>

      <div className="team-lineup">
        <h3>{match.second_team_name}</h3>
        <div className="lineup-section">
          <h4>Kaleci</h4>
          {renderPlayers(match.second_team_name, "kaleci")}
          <h4>Defans</h4>
          {renderPlayers(match.second_team_name, "defans")}
          <h4>Orta Saha</h4>
          {renderPlayers(match.second_team_name, "orta saha")}
          <h4>Forvet</h4>
          {renderPlayers(match.second_team_name, "forvet")}
        </div>
      </div>
    </div>
  );
};

export default MatchLineup;
